import { userTipsAtom } from "state-atoms/users-atoms";
import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { TipName } from "shared/datamodel/schemas";

export function useCanvasOnboardingPhase(phases: TipName[]) {
  const userTips = useAtomValue(userTipsAtom);

  return useMemo(() => {
    const filteredPhases = phases.filter((phase) => !userTips.has(phase));

    return filteredPhases.length === 0 ? null : filteredPhases[0];
  }, [userTips, phases]);
}
